import { render } from "./DiagramComponentEditorCmp.vue?vue&type=template&id=9d5882a2"
import script from "./DiagramComponentEditorCmp.vue?vue&type=script&lang=js"
export * from "./DiagramComponentEditorCmp.vue?vue&type=script&lang=js"

import "./DiagramComponentEditorCmp.vue?vue&type=style&index=0&id=9d5882a2&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__